const HEAT_MAP_COLORS = {
    0: "#0f2237",
    1: "#1c2d3f",
    2: "#264770",
    3: "#2d5e9c",
    4: "#377dcb",
    5: "#4499fa",
    6: "#40bfff",
}

const TEXT_COLORS = {
    0: "#ADADAD",
    1: "#ADADAD",
    2: "#A1A1A1",
    3: "#B8B8B8",
    4: "#000000",
    5: "#000000",
    6: "#000000",
}

const WEEK_DAYS = [
    { value: 1, label: "Seg" },
    { value: 2, label: "Ter" },
    { value: 3, label: "Qua" },
    { value: 4, label: "Qui" },
    { value: 5, label: "Sex" },
    { value: 6, label: "Sab" },
    { value: 0, label: "Dom" },
];

export default function DashHeatMap({ data = [], className = "" }) {
    const periods = [...new Map(
        [...data].sort((a, b) => a.hourFrom - b.hourFrom)
            .map(item => [item.hourFrom, { hourFrom: item.hourFrom, label: item.periodLabel }])
    ).values()];

    const dataMap = new Map(
        data.map(item => [
          `${item.dayOfWeek}-${item.hourFrom}`,
          item,
        ])
    );

    const getCellData = (dayOfWeek, hourFrom) => {
        return dataMap.get(`${dayOfWeek}-${hourFrom}`) ?? { dayOfWeek, hourFrom, qty: 0 }
    }

    const getCellColor = qty => {
        const level = Math.min(Math.max(Number(qty) || 0, 0), 6);

        return HEAT_MAP_COLORS[level];
    }

    const getTextColor = qty => {
        const level = Math.min(Math.max(Number(qty) || 0, 0), 6);

        return TEXT_COLORS[level];
    }

    return (
        <div className={`dash-heat-map ${className}`}>
            <div className="dash-heat-map__periods">
                {periods.map(period => (
                    <span key={period.hourFrom} className="dash-heat-map__period-label text-[14px]!">
                        {period.label}
                    </span>
                ))}
            </div>

            <div className="dash-heat-map__content">
                <div
                    className="dash-heat-map__grid"
                    style={{
                        gridTemplateRows: `repeat(${periods.length}, minmax(0, 1fr))`,
                    }}
                >
                    {periods.map((period, rowIndex) =>
                        WEEK_DAYS.map((day, columnIndex) => {
                            const cell = getCellData(day.value, period.hourFrom);
                            const cellIndex = rowIndex * WEEK_DAYS.length + columnIndex;

                            return (
                                <div
                                    key={`${day.value}-${period.hourFrom}`}
                                    className="dash-heat-map__cell"
                                    style={{
                                        backgroundColor: getCellColor(cell.qty),
                                        color: getTextColor(cell.qty),
                                        "--beam-delay": `${cellIndex * 30}ms`,
                                    }}
                                >
                                    <span>{cell.qty}</span>
                                </div>
                            );
                        })
                    )}
                </div>

                <div className="dash-heat-map__days">
                    {WEEK_DAYS.map(day => (
                        <span key={day.value} className="dash-heat-map__day-label text-[12px]!">
                            {day.label}
                        </span>
                    ))}
                </div>
            </div>
        </div>
    );
}
